var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenDarkBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9452_2978)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9452_2978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3516 17.0889C30.3306 16.9562 30.1176 15.7637 29.2536 14.8929C28.3858 14.0439 27.1888 13.8339 27.0553 13.8129C26.8776 13.7837 26.6961 13.8212 26.5438 13.9157C26.4906 13.9487 25.7083 14.4384 24.1641 15.7442C24.9583 16.0247 25.9851 16.5114 26.8176 17.3259C27.6531 18.1434 28.1526 19.1492 28.4391 19.9292C29.7291 18.4217 30.2143 17.6582 30.2466 17.6057C30.3426 17.4519 30.3801 17.2682 30.3516 17.0889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7132 16.917C21.9084 17.643 20.9717 18.525 19.8992 19.59C15.3519 24.105 14.1594 25.9102 14.1107 25.9845C14.0424 26.0895 14.0012 26.2102 13.9914 26.3347L13.7522 29.388C13.7357 29.607 13.8144 29.8215 13.9697 29.9767C14.1107 30.1177 14.3019 30.1965 14.5007 30.1965C14.5194 30.1965 14.5389 30.1965 14.5584 30.1942L17.6342 29.9572C17.7579 29.9475 17.8772 29.9077 17.9814 29.841C18.0564 29.793 19.8737 28.6087 24.4202 24.0945C25.5167 23.0055 26.4212 22.0575 27.1614 21.2467C27.0482 20.76 26.6529 19.371 25.6577 18.3982C24.6482 17.4105 23.1962 17.0235 22.7132 16.917Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9452_2978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9452_2978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenDarkBg);
export default __webpack_public_path__ + "static/media/pen-dark-bg.cbb981ed75b95c73c665366c361d6a25.svg";
export { ForwardRef as ReactComponent };